export default __webpack_public_path__ + "static/media/twitter-1446403018182873088.232041c4.jpg";